/**
* DevExtreme (dx.all.js)
* Version: 21.2.15
* Build date: Fri Dec 08 2023
*
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
*/
// This file is required to compile devextreme-angular